module.exports = "<div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-8 hidden-xs hidden-sm\">\n    <div class=\"lightest-gray-bg well\">\n        <img src=\"http://www.lib.tuke.sk/wwwroot/lib/assets/img/UK/Info/Vianoce_UK_%202017.jpg\" alt=\"\" width=\"100%\" class=\"img-rounded\">\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/login-banner/login-banner.component.html
// module id = ./src/app/+app-custom/components/login-banner/login-banner.component.html
// module chunks = main